app.registerLib('globalEventRegistry', function (app) {

	var helpers = app.helpers.funcs;
	var o = {};
	o.events = [];

	o.addListener = function(funcEvents, func, funcKey) {
		o.events[o.events.length] = {
			key: funcKey,
			events: funcEvents,
			func: func
		};
	};

	o.removeListener = function(funcKey) {
		o.events = o.events.filter(function(evt) {
			return evt.key !== funcKey;
		});
	};

	o.runEvents = function (evtKey, e, loadData) {
        loadData = typeof loadData !== 'undefined' ? loadData : false;
	    o.events.forEach(function (evt) {
	        if (
                (evt.events == evtKey) ||
				( (evt.events instanceof Array) && ($.inArray(evtKey, evt.events) > -1) )
			) {
				evt.func(app, e, loadData);
			}
	    });
	};

	return o;

});